import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "lp-retirement-calculator" }
const _hoisted_3 = { class: "mb-3 mb-lg-4" }
const _hoisted_4 = { class: "mb-3 mb-lg-4" }
const _hoisted_5 = { class: "mb-3 mb-lg-4" }
const _hoisted_6 = { class: "mb-3 mb-lg-4" }
const _hoisted_7 = { class: "calculator__total" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Monthly Savings Required", -1)
const _hoisted_9 = { class: "calculator-total__number" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "$", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "lp-calculator-disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_group_input = _resolveComponent("base-group-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.cssClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_group_input, {
              inputLabel: "Amount Needed at Retirement",
              "front-group": "$",
              "required-flag": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  label: "Amount Needed at Retirement",
                  modelValue: _ctx.amountNeeded,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amountNeeded) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  placeholder: "2500000",
                  "show-label": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_base_group_input, {
              "required-flag": true,
              inputLabel: "Average Return Rate",
              "back-group": "%"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  label: "Average Return Rate",
                  modelValue: _ctx.avgReturnRate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.avgReturnRate) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  step: "0.1",
                  placeholder: "6",
                  "show-label": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_base_group_input, {
              inputLabel: "Years Until Retirement",
              "back-group": "Years",
              "required-flag": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  label: "Years Until Retirement",
                  modelValue: _ctx.yearsUntilRetirement,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.yearsUntilRetirement) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  placeholder: "20",
                  "show-label": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_base_group_input, {
              inputLabel: "Current Retirement Savings",
              "front-group": "$",
              "required-flag": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_input, {
                  label: "Current Retirement Savings",
                  modelValue: _ctx.currentSavings,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentSavings) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  placeholder: "15000",
                  "show-label": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_ctx.monthlySavingsRequired.toLocaleString()), 1)
            ])
          ]),
          _hoisted_11
        ]),
        _renderSlot(_ctx.$slots, "cta")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_12, [
      _renderSlot(_ctx.$slots, "disclaimer")
    ])
  ], 64))
}